import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '../../components/ui/Button'
import { LeftArrowWhite } from '../../assets/images/svg/LeftArrow'
import EmailInput from '../../components/ui/EmailInput'
import { observer } from 'mobx-react'
import { applicationStore } from 'src/store/ApplicationStore'
import { toast } from 'react-toastify'
import Preloader from 'src/components/ui/Preloader'
import { workflowStepIterator } from 'src/services/workflowStepIterator'
import { NodeTypes } from 'src/enums/NodeTypes'
import { parseServiceErrorMessage } from 'src/helpers/parseServiceError'
import { useTranslation } from 'react-i18next'

const EmailVerification = observer(() => {
    const [isActive, setIsActive] = useState(false)
    const [email, setEmail] = useState(null)
    const [submitting, setSubmitting] = useState(false)
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleSendEmail = async () => {
        try {
            setSubmitting(true)
            const response = await workflowStepIterator({
                access_token: applicationStore.access_token,
                node_id: applicationStore.workflowNextServiceResponse.node_id,
                body: {
                    email
                },
                action_index: 0,
                constextOfStep: { step: NodeTypes.EMAIL_VERIFICATION, "retry": applicationStore.workflowNextServiceResponse.retry }
            })
            if (response.data?.service_results[0].status !== 200) {
                const rawMessage = response.data?.service_results[0]?.message;
                const parsedMessage = parseServiceErrorMessage(rawMessage);
                throw new Error(parsedMessage);
            } else {
                toast.success(t('confirmEmail.emailSent'))
                applicationStore.setEmail(email)
                applicationStore.setWorkflowNextServiceResponse(response.data);
                navigate("/confirm-email", { replace: true, state: { email } })
            }
        } catch (error) {
            toast.error(error?.message || t('confirmEmail.emailNotSent'))
        } finally {
            setSubmitting(false)
        }
    }

    return (
        <div className="custom-container">
            <div className="flex w-full flex-col text-left h-full">
                <div className="w-full">
                    <div className='text-left'>
                        <Button className="" variant="primaryBack" onClick={() => { navigate(`/?aid=${applicationStore.aidCode}`, { replace: true }) }}><LeftArrowWhite /></Button>
                    </div>
                    <div className='grid gap-[16px] mt-10 w-full text-left'>
                        <div className="text-h5 font-bold text-flow-heading">{t('emailVerification.title')}</div>
                        <div className="text-body text-Gray900">{t('emailVerification.description')}</div>
                    </div>
                    <div className='mt-10'>
                        <EmailInput setIsActive={setIsActive} setValue={setEmail} />
                    </div>
                    <div className='mt-6 w-full'>
                        <Button className="mt-4" variant="primaryWithoutIcon" disabled={!isActive || submitting} onClick={handleSendEmail}>
                            <span className="me-1">{t('actions.continue')}</span>{submitting && <Preloader variant='white' />}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
})

export default EmailVerification
